import { type ActionType, createAction } from 'typesafe-actions';
import type { DeviceType } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';

export const setDeviceType = createAction('SET_DEVICE_TYPE')<DeviceType>();

export type ThemeActions = ActionType<typeof setDeviceType>;
